export class Atlona {
    constructor(socket, log) {
        this.socket = socket;
        this.autoSwitch = false;
        this.numberOfVideoOutputs = 2;
        this.power = false;
        this.usbHost = 'C';
        this.usbMode = 'follow video';
        this.version = '1.2.3';
        this.videoOutputs = Array(16).fill('1');
        this.outputMute = Array(16).fill(false);
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /AutoSW (on|off|sta)/i,
                callback: (match) => {
                    const argument = match[1].toLowerCase();
                    if (argument !== 'sta') {
                        this.autoSwitch = argument === 'on';
                    }
                    this.socket.send(`AutoSw ${this.autoSwitch ? 'on' : 'off'}`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /Version/i,
                callback: (match) => {
                    this.socket.send(`${this.version}`);
                },
            },
            {
                name: 'getVideoSwitch',
                regExp: /Status/i,
                callback: (match) => {
                    this.socket.send(this.matrixRouting());
                },
            },
            {
                name: 'powerQuery',
                regExp: /PWSTA/i,
                callback: (match) => {
                    this.socket.send(this.power ? 'PWON' : 'PWOFF');
                },
            },
            {
                name: 'powerSet',
                regExp: /PW(ON|OFF)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(this.power ? 'PWON' : 'PWOFF');
                },
            },
            {
                name: 'routeToAllOutputs',
                regExp: /x(\d+)All/i,
                callback: (match) => {
                    for (let i = 0; i < this.numberOfVideoOutputs; i++) {
                        this.videoOutputs[i] = match[1];
                    }
                    this.socket.send(`x${match[1]}All`);
                },
            },
            {
                name: 'usbHost',
                regExp: /USBHostRoute\s+(.+)/i,
                callback: (match) => {
                    if (match[1] !== 'sta') {
                        this.usbHost = match[1];
                    }
                    this.socket.send(`USBHostRoute ${this.usbHost}`);
                },
            },
            {
                name: 'usbMode',
                regExp: /USBHostLogic\s+(follow\s+usb|follow\s+video|manual|sta)/i,
                callback: (match) => {
                    if (match[1] !== 'sta') {
                        this.usbMode = match[1];
                    }
                    this.socket.send(`USBHostLogic ${this.usbMode}`);
                },
            },
            {
                name: 'videoSwitch',
                regExp: /x(\d+)AVx(\d+)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[2], 10) - 1;
                    this.videoOutputs[outputNum] = match[1] ? match[1] : '1';
                    this.socket.send(`x${match[1]}AVx${match[2]}`);
                },
            },
            {
                name: 'volumeMute',
                regExp: /VOUTMute(\d+)\s+(on|off|sta)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    if (match[2] !== 'sta') {
                        this.outputMute[outputNum] = match[2] === 'on';
                    }
                    this.socket.send(`VOUTMute${match[1]} ${this.outputMute[outputNum] ? 'on' : 'off'}`);
                },
            },
            {
                name: 'invalid',
                regExp: /(.+)/i,
                callback: (match) => {
                    this.socket.send(`Command FAILED: ${match[0]}`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.numberOfVideoOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
    }
    matrixRouting() {
        let response = '';
        for (let i = 0; i < this.numberOfVideoOutputs; i++) {
            response += `x${this.videoOutputs[i]}AVx${i + 1}`;
            if (i !== this.numberOfVideoOutputs - 1) {
                response += ',';
            }
        }
        return response;
    }
}
Atlona.emulatorType = 'socketEmulator';
Atlona.key = '-LwEpli5F-pAkqai069c';
